import gql from 'graphql-tag';
import { AUTHOR_FRAGMENT } from './author.fragment';
import { TAG_FRAGMENT } from './tag.fragment';

export const LINK_FRAGMENT = gql`
  fragment LinkData on VideoLink {
    id
    originalLanguage
    link
    authors {
      ...AuthorData
    }
    content {
      description
      language
      title
      translator
    }
    tags {
      ...TagData
    }
  }
  ${AUTHOR_FRAGMENT}
  ${TAG_FRAGMENT}
`;
